import { useState, useEffect } from "react";
import axios from "axios";
import API_ENDPOINTS from "config/api";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";

export default function Capacitaciones() {
  const [capacitaciones, setCapacitaciones] = useState([]);

  useEffect(() => {
    const fetchCapacitaciones = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.RRHH.CAPACITACIONES);
        setCapacitaciones(response.data);
      } catch (error) {
        console.error("Error al cargar capacitaciones:", error);
      }
    };
    fetchCapacitaciones();
  }, []);

  const getEstatusColor = (estatus) => {
    switch (estatus) {
      case "Completado":
        return "success";
      case "En Curso":
        return "info";
      case "Programado":
        return "warning";
      default:
        return "default";
    }
  };

  const columns = [
    {
      Header: "curso",
      accessor: "curso",
      width: "30%",
    },
    {
      Header: "instructor",
      accessor: "instructor",
      width: "20%",
    },
    {
      Header: "fecha",
      accessor: "fecha",
      width: "12%",
    },
    {
      Header: "duración",
      accessor: "duracion",
      width: "10%",
    },
    {
      Header: "inscritos",
      accessor: "inscritos",
      width: "10%",
    },
    {
      Header: "estatus",
      accessor: "estatus",
      width: "12%",
    },
    {
      Header: "acciones",
      accessor: "acciones",
      width: "10%",
    },
  ];

  const rows = capacitaciones.map((item) => ({
    curso: (
      <MDTypography variant="caption" fontWeight="medium">
        {item.curso}
      </MDTypography>
    ),
    instructor: <MDTypography variant="caption">{item.instructor}</MDTypography>,
    fecha: <MDTypography variant="caption">{item.fecha}</MDTypography>,
    duracion: <MDTypography variant="caption">{item.duracion}</MDTypography>,
    inscritos: (
      <MDTypography variant="caption" fontWeight="bold" color="info">
        {item.inscritos}
      </MDTypography>
    ),
    estatus: <Chip label={item.estatus} color={getEstatusColor(item.estatus)} size="small" />,
    acciones: (
      <MDBox display="flex" gap={1}>
        <MDButton variant="text" color="info" size="small" iconOnly>
          <Icon>visibility</Icon>
        </MDButton>
        <MDButton variant="text" color="dark" size="small" iconOnly>
          <Icon>edit</Icon>
        </MDButton>
      </MDBox>
    ),
  }));

  return (
    <MDBox>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <Icon sx={{ fontSize: 48, color: "success.main" }}>school</Icon>
              <MDTypography variant="h6" color="text" mt={1}>
                Cursos Completados
              </MDTypography>
              <MDTypography variant="h3" color="success" fontWeight="bold">
                1
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <Icon sx={{ fontSize: 48, color: "info.main" }}>play_circle</Icon>
              <MDTypography variant="h6" color="text" mt={1}>
                En Curso
              </MDTypography>
              <MDTypography variant="h3" color="info" fontWeight="bold">
                1
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <Icon sx={{ fontSize: 48, color: "warning.main" }}>schedule</Icon>
              <MDTypography variant="h6" color="text" mt={1}>
                Programados
              </MDTypography>
              <MDTypography variant="h3" color="warning" fontWeight="bold">
                2
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <Icon sx={{ fontSize: 48, color: "dark.main" }}>people</Icon>
              <MDTypography variant="h6" color="text" mt={1}>
                Total Inscritos
              </MDTypography>
              <MDTypography variant="h3" color="dark" fontWeight="bold">
                100
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
      </Grid>

      <Card>
        <MDBox p={3}>
          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <MDTypography variant="h6" fontWeight="medium">
              Plan de Capacitación
            </MDTypography>
            <MDButton variant="gradient" color="success">
              <Icon>add</Icon>&nbsp;Nuevo Curso
            </MDButton>
          </MDBox>

          <DataTable
            table={{ columns, rows }}
            showTotalEntries={true}
            isSorted={true}
            noEndBorder
            entriesPerPage={true}
          />
        </MDBox>
      </Card>
    </MDBox>
  );
}
